
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MenubarItem } from '@k12/app-components';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-material-header',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './material-header.component.html',
  styleUrl: './material-header.component.scss'
})
export class LibMaterialHeaderComponent {
  @Input() topMenu: MenubarItem[] | undefined;
  @Input() isAdmin: boolean = false;
  isLoggedin: boolean = false;
  userMenu: MenubarItem[] | undefined;
  constructor() {
    this.userMenu = [
      {
        label: 'Logout',
        command: () => {
          this.isLoggedin = !this.isLoggedin;
        }
      }
    ];
  }
}
